<div class="header-container">
  <div class="header-text">
    <h2 class="typography-title-xl">{{ titulo }}</h2>
    <span *ngIf="textoSecundario" class="subtext">{{ textoSecundario }}</span>
  </div>

  <div class="header-image">
    <img [src]="urlImagenHeader" alt="Imagen del header" />
  </div>

  <div class="divider"></div>
</div>
